var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('user-dashboard',{attrs:{"auto-refresh":true,"stat-bar-stats":_vm.statBarStats,"graph-stats":_vm.graphStats,"table-fields":_vm.tableFields,"table-stats":_vm.tableStats,"stat-bar-sub-stats":_vm.statBarSubStats}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e498036","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/admin/pages/Dashboard.vue
// module id = null
// module chunks = 